import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { postLogin, getList, addData } from '../../helpers/fackBackend_Helper';

function* loginResponse({ payload: { data } }) {
    try {
        const response = yield call(postLogin, '/API/V1/Auth/Login', data);
        if (response?.statusCode == 1200) {
            yield put(actions.loginSuccess(response?.data, response?.message));
        } else {
            yield put(actions.loginFailed(response?.message));
        }
    } catch (error) {
        yield put(actions.loginFailed(error));
    }
}

function* verifyOtpResponse({ payload: { data } }) {
    try {
        const response = yield call(postLogin, '/API/V1/Auth/VerifyOtp', data);
        if (response?.statusCode == 1200) {
            yield put(actions.verifyOtpSuccess(response?.data, response?.message));
        } else {
            yield put(actions.verifyOtpFailed(response?.message));
        }
    } catch (error) {
        yield put(actions.verifyOtpFailed(error));
    }
}

function* userDataByTokenResponse() {
    try {
        const response = yield call(getList, '/API/V1/Generic/GetUserByToken');
        if (response?.statusCode == 1200) {
            yield put(actions.getUserDataByTokenSuccess(response?.data));
        }
        else {
            yield put(actions.getUserDataByTokenError(response?.message));
        }
    } catch (error) {
        yield put(actions.getUserDataByTokenError(error));
    }
}

function* forgotPasswordResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/API/V1/Auth/ForgetPassword', data);
        if (response?.statusCode == 1200) {
            yield put(actions.forgotPasswordSuccess(response?.message || 'Your password has been sent to your registered email address.'));
        } else {
            yield put(actions.forgotPasswordFailed(response?.message || "Something went wrong. Please try again."));
        }
    } catch (error) {
        yield put(actions.forgotPasswordFailed(error));
    }
}

function* resetPasswordResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/API/V1/User/ResetPassword', data);
        if (response?.statusCode == 1200) {
            yield put(actions.resetPasswordSuccess(response?.message));
        } else {
            yield put(actions.resetPasswordFailed(response?.message));
        }
    } catch (error) {
        yield put(actions.resetPasswordFailed(error));
    }
}

function* FundMangementResponse({ payload: { data }, }) {
    try {
        const response = yield call(addData, "/API/V1/AddFund/AddFunds", data);
        if (response?.statusCode === 1200) {
            yield put(actions.fundManagementSuccess(response?.message));
        } else {
            yield put(actions.fundManagementError(response?.message));
        }
    } catch (error) {
        yield put(actions.fundManagementError(error?.message || error));
    }
}

function* getLatestfundManagementDataResponse() {
    try {
        const response = yield call(getList, "/api/V1/Reports/TopUpdata");
        if (response?.statusCode === 1200) {
            yield put(actions.getLatestfundManagementDataSuccess(response?.data));
        } else {
            yield put(actions.getLatestfundManagementDataError(response?.message));
        }
    } catch (error) {
        yield put(actions.getLatestfundManagementDataError(error?.message || error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.LOGIN, loginResponse)]);
    yield all([takeEvery(actions.VERIFY_OTP, verifyOtpResponse)]);
    yield all([takeEvery(actions.GET_USER_DATA_BY_TOKEN, userDataByTokenResponse)]);
    yield all([takeEvery(actions.FORGOT_PASSWORD, forgotPasswordResponse)]);
     yield all([takeEvery(actions.RESET_PASSWORD, resetPasswordResponse)]);
    yield all([takeEvery(actions.FUND_MANAGEMENT, FundMangementResponse)]);
     yield all([takeEvery(actions.GET_LATEST_FUND_MANAGEMENT_DATA, getLatestfundManagementDataResponse)]);

}
